const LOCALES = {
  en: {
    'form.title': 'Get in touch',
    'form.submit': 'Submit',
    'form.cancel': 'Cancel',
    'form.sending': 'Sending…',
    'form.close': 'Close form',
    'form.thankYou': 'Thank you!',
    'form.headline': 'Contact Us',
    'form.description': 'Fill out the form below and we will get back to you.',
    'form.successMessage': 'Thanks for contacting us!',
    'form.contact': 'Contact',
    'form.contactUs': 'Contact Us',
    'form.formOpen': 'Form Open',
    'form.required': '{label} is required',
    'form.invalidUrl': 'Please enter a valid website URL',
    'field.firstName': 'First name',
    'field.lastName': 'Last name',
    'field.name': 'Name',
    'field.email': 'Email',
    'field.phone': 'Phone',
    'field.company': 'Company',
    'field.website': 'Website',
    'field.comments': 'Comments',
    'orderStatus.formTitle': 'Order status',
    'orderStatus.formSubtitle': 'Enter your order number and one verification detail.',
    'orderStatus.submitLabel': 'Look up order',
    'orderStatus.orderNumberLabel': 'Order number',
    'orderStatus.verifyWith': 'Verify with',
    'orderStatus.verify.email': 'Email on the order',
    'orderStatus.verify.phone': 'Phone on the order',
    'orderStatus.verify.shipping_zip': 'Shipping ZIP / Postal Code',
    'orderStatus.close': 'Close',
    'orderStatus.searching': 'Searching…',
    'orderStatus.lookupFailed': 'Order lookup failed.',
    'orderStatus.tracking': 'Tracking',
    'orderStatus.returnToMenu': 'Return to menu',
    'orderStatus.contactUs': 'Contact us',
  },
  es: {
    'form.title': 'Contáctenos',
    'form.submit': 'Enviar',
    'form.cancel': 'Cancelar',
    'form.sending': 'Enviando…',
    'form.close': 'Cerrar formulario',
    'form.thankYou': '¡Gracias!',
    'form.headline': 'Contáctenos',
    'form.description': 'Complete el formulario y nos pondremos en contacto con usted.',
    'form.successMessage': '¡Gracias por contactarnos!',
    'form.contact': 'Contacto',
    'form.contactUs': 'Contáctenos',
    'form.formOpen': 'Formulario abierto',
    'form.required': '{label} es obligatorio',
    'form.invalidUrl': 'Introduzca una URL de sitio web válida',
    'field.firstName': 'Nombre',
    'field.lastName': 'Apellido',
    'field.name': 'Nombre',
    'field.email': 'Correo electrónico',
    'field.phone': 'Teléfono',
    'field.company': 'Empresa',
    'field.website': 'Sitio web',
    'field.comments': 'Comentarios',
    'orderStatus.formTitle': 'Estado del pedido',
    'orderStatus.formSubtitle': 'Introduzca su número de pedido y un dato de verificación.',
    'orderStatus.submitLabel': 'Buscar pedido',
    'orderStatus.orderNumberLabel': 'Número de pedido',
    'orderStatus.verifyWith': 'Verificar con',
    'orderStatus.verify.email': 'Correo del pedido',
    'orderStatus.verify.phone': 'Teléfono del pedido',
    'orderStatus.verify.shipping_zip': 'Código postal de envío',
    'orderStatus.close': 'Cerrar',
    'orderStatus.searching': 'Buscando…',
    'orderStatus.lookupFailed': 'No se pudo buscar el pedido.',
    'orderStatus.tracking': 'Seguimiento',
    'orderStatus.returnToMenu': 'Volver al menú',
    'orderStatus.contactUs': 'Contáctenos',
  },
  fr: {
    'form.title': 'Contactez-nous',
    'form.submit': 'Envoyer',
    'form.cancel': 'Annuler',
    'form.sending': 'Envoi…',
    'form.close': 'Fermer le formulaire',
    'form.thankYou': 'Merci !',
    'form.headline': 'Contactez-nous',
    'form.description': 'Remplissez le formulaire et nous vous répondrons.',
    'form.successMessage': 'Merci de nous avoir contactés !',
    'form.contact': 'Contact',
    'form.contactUs': 'Contactez-nous',
    'form.formOpen': 'Formulaire ouvert',
    'form.required': '{label} est obligatoire',
    'form.invalidUrl': 'Veuillez entrer une URL de site web valide',
    'field.firstName': 'Prénom',
    'field.lastName': 'Nom',
    'field.name': 'Nom',
    'field.email': 'E-mail',
    'field.phone': 'Téléphone',
    'field.company': 'Entreprise',
    'field.website': 'Site web',
    'field.comments': 'Commentaires',
    'orderStatus.formTitle': 'Statut de la commande',
    'orderStatus.formSubtitle': 'Entrez votre numéro de commande et un détail de vérification.',
    'orderStatus.submitLabel': 'Rechercher la commande',
    'orderStatus.orderNumberLabel': 'Numéro de commande',
    'orderStatus.verifyWith': 'Vérifier avec',
    'orderStatus.verify.email': 'E-mail de la commande',
    'orderStatus.verify.phone': 'Téléphone de la commande',
    'orderStatus.verify.shipping_zip': 'Code postal de livraison',
    'orderStatus.close': 'Fermer',
    'orderStatus.searching': 'Recherche…',
    'orderStatus.lookupFailed': 'Échec de la recherche de commande.',
    'orderStatus.tracking': 'Suivi',
    'orderStatus.returnToMenu': 'Retour au menu',
    'orderStatus.contactUs': 'Contactez-nous',
  },
  it: {
    'form.title': 'Contattaci',
    'form.submit': 'Invia',
    'form.cancel': 'Annulla',
    'form.sending': 'Invio…',
    'form.close': 'Chiudi modulo',
    'form.thankYou': 'Grazie!',
    'form.headline': 'Contattaci',
    'form.description': 'Compila il modulo e ti risponderemo.',
    'form.successMessage': 'Grazie per averci contattato!',
    'form.contact': 'Contatto',
    'form.contactUs': 'Contattaci',
    'form.formOpen': 'Modulo aperto',
    'form.required': '{label} è obbligatorio',
    'form.invalidUrl': 'Inserisci un URL del sito web valido',
    'field.firstName': 'Nome',
    'field.lastName': 'Cognome',
    'field.name': 'Nome',
    'field.email': 'Email',
    'field.phone': 'Telefono',
    'field.company': 'Azienda',
    'field.website': 'Sito web',
    'field.comments': 'Commenti',
    'orderStatus.formTitle': 'Stato ordine',
    'orderStatus.formSubtitle': 'Inserisci il numero ordine e un dato di verifica.',
    'orderStatus.submitLabel': 'Cerca ordine',
    'orderStatus.orderNumberLabel': 'Numero ordine',
    'orderStatus.verifyWith': 'Verifica con',
    'orderStatus.verify.email': "Email dell'ordine",
    'orderStatus.verify.phone': "Telefono dell'ordine",
    'orderStatus.verify.shipping_zip': 'CAP / codice postale di spedizione',
    'orderStatus.close': 'Chiudi',
    'orderStatus.searching': 'Ricerca…',
    'orderStatus.lookupFailed': 'Ricerca ordine non riuscita.',
    'orderStatus.tracking': 'Tracciamento',
    'orderStatus.returnToMenu': 'Torna al menu',
    'orderStatus.contactUs': 'Contattaci',
  },
}

const SUPPORTED = new Set(['en', 'es', 'fr', 'it'])

export function resolveLocale(lang) {
  if (!lang || typeof lang !== 'string') return 'en'
  const primary = lang.trim().toLowerCase().replace('_', '-').split('-')[0]
  return SUPPORTED.has(primary) ? primary : 'en'
}

export function t(key, lang, vars = {}) {
  const locale = resolveLocale(lang)
  const table = LOCALES[locale] || LOCALES.en
  let text = table[key] || LOCALES.en[key] || key
  for (const [name, value] of Object.entries(vars)) {
    text = text.replaceAll(`{${name}}`, String(value))
  }
  return text
}

export function fieldLabel(name, lang) {
  const key = {
    firstName: 'field.firstName',
    lastName: 'field.lastName',
    name: 'field.name',
    email: 'field.email',
    phone: 'field.phone',
    company: 'field.company',
    website: 'field.website',
    comments: 'field.comments',
  }[name]
  if (key) return t(key, lang)
  return name.charAt(0).toUpperCase() + name.slice(1)
}

export function verificationLabel(type, lang) {
  return t(`orderStatus.verify.${type}`, lang) || type
}
